import { configureStore } from '@reduxjs/toolkit';
// import grpoReducer from './redux/grpo/grpoSlice';  
import grpoReducer from './ProductionService/GRPOServices/GRPOSlice';
import alertReducer from './alertSlice';
import loginReducer from './Login/loginSlice'; 
import ITReducer from './ProductionService/ITServices/ITSlice';
// import PaymentCollectionReducer from './PaymentCollectionServices/PaymentCollectionSlice';
import { ITPostingReducer } from './ProductionService/InventoryPosting/inventoryPostingSlic';
import {deliveryReducer}from'./ProductionService/DeliveryService/DeliveryServiceSlice'
import DisassembleReducer from './ProductionService/DisassembleService/DisassembleSlice';
import ProductionFgReducer from './ProductionService/ProductionFgService/ProductionFgSlice';
import loaderReducer from './LoaderSlice';
import orderReducer from './SalesService/OrderService/OrderSlice';
import HistoryReducer from './SalesService/OrderHistory/HistorySlice';
import DeliveryHistoryReducer from './SalesService/DeliveryService/deliverySlice';
import InvoiceHistoryReducer from './SalesService/InvoiceService/invoiceSlice';
import BackupQRReducer from './ProductionService/BackupQRcode/backupGenerateQrSlice';
import ReturnReducer from './ProductionService/Return/returnSlice';




const store = configureStore({
  reducer: {
    login: loginReducer,
    grpo: grpoReducer,
    alert: alertReducer,
    InvTransfer:ITReducer,
    // paymentCollection: PaymentCollectionReducer,
    InvPosting:ITPostingReducer,
    delivery:deliveryReducer,
    Disassemble:DisassembleReducer,
    ProductionFg:ProductionFgReducer,
    loader: loaderReducer,
    order:orderReducer,
    ReturnData:ReturnReducer,
    orderHistory:HistoryReducer,
    Delivery:DeliveryHistoryReducer,
    Invoice:InvoiceHistoryReducer,
    GenerateBackUpQR:BackupQRReducer
  },
});

export default store;


// store.js
// store.js
// import { configureStore } from '@reduxjs/toolkit';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage'; // Using localStorage for web
// import sessionStorage from 'redux-persist/lib/storage/session';
// import grpoReducer from './GRPOServices/GRPOSlice';
// import userReducer from './userReducer';
// import alertReducer from './alertSlice';
// import { itemReducer } from './itemReducer';

// const persistConfig = {
//   key: 'root',
//   storage: sessionStorage,
//   whitelist: ['grpo'], // Only persist the `grpo` reducer
// };

// const persistedGrpoReducer = persistReducer(persistConfig, grpoReducer);

// const store = configureStore({
//   reducer: {
//     grpo: persistedGrpoReducer,
//     user: userReducer,
//     alert: alertReducer,
//     item: itemReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ['persist/PERSIST'],  // Ignore persist actions for serializability
//       },
//     }),
// });

// export const persistor = persistStore(store); // Create a persistor for rehydration

// export default store;
